import React from "react";
import { Outlet } from "react-router-dom";

const AssetComponent = () => {
  return (
    <Outlet />
  );
};

export default AssetComponent;
